import React, { useState, useEffect } from 'react';
import { updateCookieConsent } from '../../utils/cookieConsent';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    updateCookieConsent('all');
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    updateCookieConsent('necessary');
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    updateCookieConsent('rejected');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      {/* Main Banner */}
      <div className="cookie-consent-main">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h5 className="mb-2">🍪 We use cookies to enhance your experience</h5>
              <p className="mb-0 text-muted">
                We use cookies and similar technologies to help personalize content, 
                provide and improve our services, and analyze our traffic. 
                <button 
                  className="btn btn-link p-0 ms-1 text-decoration-none"
                  onClick={() => setShowDetails(true)}
                >
                  Learn more
                </button>
              </p>
            </div>
            <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
              <div className="d-flex flex-column flex-sm-row gap-2 justify-content-lg-end">
                <button 
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleRejectAll}
                >
                  Reject All
                </button>
                <button 
                  className="btn btn-outline-primary btn-sm"
                  onClick={handleAcceptNecessary}
                >
                  Accept Necessary
                </button>
                <button 
                  className="btn btn-primary btn-sm"
                  onClick={handleAcceptAll}
                >
                  Accept All
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detailed Modal */}
      {showDetails && (
        <div className="cookie-consent-modal">
          <div className="cookie-consent-overlay" onClick={() => setShowDetails(false)}></div>
          <div className="cookie-consent-modal-content">
            <div className="d-flex justify-content-between align-items-start mb-4">
              <h4>Cookie Preferences</h4>
              <button 
                className="btn-close"
                onClick={() => setShowDetails(false)}
              ></button>
            </div>
            
            <div className="mb-4">
              <p>
                We use cookies to enhance your browsing experience, serve personalized content, 
                and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
              </p>
            </div>

            <div className="cookie-categories mb-4">
              <div className="cookie-category mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Essential Cookies</h6>
                  <span className="badge bg-success">Always Active</span>
                </div>
                <p className="text-muted small mb-0">
                  These cookies are necessary for the website to function properly. 
                  They enable basic functions like page navigation and access to secure areas.
                </p>
              </div>

              <div className="cookie-category mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Analytics Cookies</h6>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="analyticsCookies"
                      defaultChecked
                    />
                  </div>
                </div>
                <p className="text-muted small mb-0">
                  These cookies help us understand how visitors interact with our website 
                  by collecting and reporting information anonymously.
                </p>
              </div>

              <div className="cookie-category mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Marketing Cookies</h6>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="marketingCookies"
                      defaultChecked
                    />
                  </div>
                </div>
                <p className="text-muted small mb-0">
                  These cookies are used to track visitors across websites to display 
                  relevant and engaging advertisements.
                </p>
              </div>

              <div className="cookie-category">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Preference Cookies</h6>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="preferenceCookies"
                      defaultChecked
                    />
                  </div>
                </div>
                <p className="text-muted small mb-0">
                  These cookies allow the website to remember choices you make and 
                  provide enhanced, more personal features.
                </p>
              </div>
            </div>

            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-end">
              <button 
                className="btn btn-outline-secondary"
                onClick={handleRejectAll}
              >
                Reject All
              </button>
              <button 
                className="btn btn-outline-primary"
                onClick={handleAcceptNecessary}
              >
                Accept Necessary
              </button>
              <button 
                className="btn btn-primary"
                onClick={handleAcceptAll}
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsent; 